import React, { useEffect, useCallback, useMemo } from "react";
import RequestService from "../../../services/request.service";
import { useHistory } from "react-router";
import EnvService from "../../../services/env.service";
import UrlService from "../../../services/url.service";
import LoadingPage from "../../../components/LoadingPage";

export default function LoginFullCallback() {
  const history = useHistory();
  const errorsToRedirect = useMemo(() => ["71000", "78000", "74000"], []);

  const goToRegisterMachine = useCallback(
    (e) => {
      try {
        const errorCode = e.response?.data?.error?.errorCode;
        if (errorCode === "75000") {
          history.push("/oauth/register-machine");
        } else if (errorCode && errorsToRedirect.includes(errorCode)) {
          history.push({
            pathname: "/authn/error",
            state: {
              error: e.response.data.error.error,
              providencia: e.response.data.error.providencia,
            },
          });
        } else {
          history.push("/error");
        }
      } catch (err) {
        console.error(err);
      }
    },
    [history, errorsToRedirect]
  );

  const loadUser = useCallback(async () => {
    const { REACT_APP_AUTH_USER_URL } = EnvService.getEnv();
    const mciPj = UrlService.getQueryString("mciPj");
    const chaveJ = UrlService.getQueryString("chaveJ");
    const codTipo = UrlService.getQueryString("codTipo");
    const additionalAuth = UrlService.getQueryString("additionalAuth");
    const domainCookie = UrlService.getQueryString("domainCookie");
    const queryParams = UrlService.getQueryParamsFromObject({
      mciPj,
      codTipo,
      chaveJ,
      additionalAuth,
      domainCookie,
    });
    const redirectAppUrl = UrlService.getQueryString("redirect_app_url");

    try {
      await RequestService.get(
        `${REACT_APP_AUTH_USER_URL}/?${queryParams}&redirect_app_url=${redirectAppUrl}`
      );

      window.location.href = redirectAppUrl;
    } catch (e) {
      console.log(e);
      goToRegisterMachine(e);
    }
  }, [goToRegisterMachine]);

  useEffect(loadUser, [loadUser]);

  return <LoadingPage />;
}
